import React from "react";
import * as styles from "./MenuItemIconOrImage.module.scss";
import { match, P } from "ts-pattern";
import { MenuItemImage } from "../../utils";
import { Icon, SanityImage } from "@silversea-ssc/ui-components-react";
import { IconsId } from "@silversea-ssc/design-system-icons";
import PackageIcon from "components/PackageIcon/PackageIcon";
import clsx from "clsx";

type Props = {
  image?: MenuItemImage;
  label: string;
  variant: "menu" | "trending";
};
const MenuItemIconOrImage: React.FC<Props> = ({ image, label, variant }) => {
  const imageComponent = match(image)
    .with({ _type: "icon", name: P.not("default") }, (icon) => {
      return (
        <Icon
          name={icon.name as IconsId}
          padding={false}
          wrapperClassName={styles.icon}
        />
      );
    })
    .with({ _type: "package-icon", name: P.not("default") }, (icon) => {
      return <PackageIcon icon={icon.name} className={styles.icon} />;
    })
    .with({ _type: "svg" }, (svgIcon) => {
      return (
        <img
          src={svgIcon.url}
          alt="icon"
          loading="lazy"
          className={styles.svgIcon}
          height={33}
          width={33}
        />
      );
    })
    .with({ asset: P.not(P.nullish) }, (i) => (
      <SanityImage
        image={i}
        alt={label}
        className={styles.image}
        width={72}
        height={64}
        loading="lazy"
        fit="crop"
      />
    ))
    .otherwise(() => null);

  if (!imageComponent) return null;

  return (
    <div
      className={clsx({
        [styles.variantMenu]: variant == "menu",
        [styles.variantTrending]: variant == "trending"
      })}
    >
      {imageComponent}
    </div>
  );
};

export default MenuItemIconOrImage;
